import { Link } from "react-router-dom";
import { MapPin, Cog } from "lucide-react";
import { machinePhotoSrc } from "../lib/api";
import { STATUS_LABEL, STATUS_STYLES } from "../lib/constants";

export default function MachineCard({ machine, index = 0 }) {
  const photo = machinePhotoSrc(machine);
  const status = STATUS_STYLES[machine.status] || STATUS_STYLES.operativa;

  return (
    <Link
      to={`/app/machines/${machine.id}`}
      data-testid={`machine-card-${machine.id}`}
      className="group block bg-white rounded-2xl border border-zinc-200/80 card-shadow card-shadow-hover overflow-hidden transition-[transform,box-shadow] duration-200 hover:-translate-y-1 active:scale-[0.98] animate-fade-up focus-visible:ring-2 focus-visible:ring-zinc-950 focus-visible:ring-offset-2"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
    >
      <div className="relative aspect-[16/10] bg-zinc-100 overflow-hidden">
        {photo ? (
          <img
            src={photo}
            alt={machine.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-zinc-300">
            <Cog size={48} strokeWidth={1.2} />
          </div>
        )}
        <span
          className={`absolute top-3 left-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium backdrop-blur-md bg-white/85 ${status.badge} border-0`}
          data-testid={`machine-status-${machine.id}`}
        >
          <span className={`h-1.5 w-1.5 rounded-full ${status.dot}`} />
          {STATUS_LABEL[machine.status] || machine.status}
        </span>
      </div>
      <div className="p-5">
        <h3 className="font-heading font-semibold text-lg tracking-tight leading-snug">
          {machine.name}
        </h3>
        <p className="text-sm text-zinc-500 mt-0.5">
          {[machine.manufacturer, machine.model].filter(Boolean).join(" · ") || "—"}
        </p>
        {machine.location_name && (
          <p className="flex items-center gap-1.5 text-sm text-zinc-400 mt-2.5">
            <MapPin size={14} />
            {machine.location_name}
          </p>
        )}
      </div>
    </Link>
  );
}
